import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  button: {
    borderRadius: 30,
    color: 'white',
    backgroundColor: '#0055a5',
    border: 0,
    fontWeight: 600,
    paddingTop: 18,
    paddingRight: 30,
    paddingLeft: 30,
    paddingBottom: 15,
    display: 'flex',
    textAlign: 'center',
    position: 'relative',
    '&:hover': {
      opacity: '.9',
      transition: 'all .5s linear',
      cursor: 'pointer'
    },
    '& span': {
      marginLeft: 25,
      position: 'absolute',
      top: '12px',
      right: '25px'
    },
  },
  hasIcon: {
    paddingBottom: '15px !important',
  },
  buttonSecondary: {
    backgroundColor: '#e20066',
  },
  tertiary: {
    backgroundColor: 'white',
    color: '#0055a5'
  },
  isDisabled: {
    backgroundColor: 'grey',
    cursor: 'not-allowed !important'
  }
}));